// Get avatar status class based on last activity time
export const getUserAvatarStatus = (updatedAt) => {
    if (!updatedAt) return "avatar-offline";

    const lastSeen = new Date(updatedAt).getTime();
    const now = Date.now();
    const secondsAgo = (now - lastSeen) / 1000;

    return secondsAgo > 60 ? "avatar-offline" : "avatar-online";
};

// Get plain text video status based on last activity time
export const getUserVideoConStatus = (updatedAt) => {
    if (!updatedAt) return "offline";

    const lastSeen = new Date(updatedAt).getTime();
    const now = Date.now();
    const secondsAgo = (now - lastSeen) / 1000;

    return secondsAgo > 65 ? "offline" : "online";
};
